import React from 'react';
import {Form, FormGroup} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const VolunteerApplicationDocuments = (props) => {

  const {t} = useTranslation('volunteer-application');

  const photoThumbs = props.application.photos.map(photoId => {
    return (
      <div className={"file-thumbnail"} key={photoId}>
        <div className={"file-thumbnail-inner"}>
          <img
            src={`${process.env.REACT_APP_API_URL}` + '/v1/volunteer/application/media/' + photoId}
            className={"file-thumbnail-image"}
            alt={'File ' + photoId}
            width="150"
            height="200"
            style={{objectFit: 'cover'}}
          />
        </div>
      </div>
    )
  });

  let resumeFiles = props.application.resumeFiles || [];

  return <div id="volunteer-application-approval-documents">
    <Form.Row>
      <FormGroup className="col-sm mb-3">
        <Form.Label>{t('volunteer-application.form.photo')}</Form.Label>
        <div className={"thumbsContainer"}>
          {photoThumbs}
        </div>
      </FormGroup>
    </Form.Row>
    <Form.Row>
      <FormGroup className="col-sm mb-3">
        <Form.Label htmlFor="resumeFiles">{t('volunteer-application.form.attached-files')}</Form.Label>
        <ul>
          {
            resumeFiles.map(mediaId => {
              let mediaFile = props.mediaFiles.find(m => m && m.mediaId === mediaId);
              if (mediaFile === undefined) {
                return null;
              }

              return (
                <li key={mediaFile.mediaId}>
                  <a href={`${process.env.REACT_APP_API_URL}` + '/v1/volunteer/application/media/' + mediaId} download={'hello'}>{mediaFile.mediaName}</a> - {mediaFile.mediaSize} bytes
                </li>
              )
            })
          }
          {
            resumeFiles.length === 0 &&
            <div><i>{t('volunteer-application.form.resume-files-none')}</i></div>
          }
        </ul>
      </FormGroup>
    </Form.Row>
  </div>
}

export default VolunteerApplicationDocuments;